import React, { useState } from "react";
import styled from "styled-components";

// Styled Components
const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Label = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: ${(props) => (props.active ? "#EE754C" : "#ccc")};
  transition: color 0.3s ease;
`;

const LabelLeft = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: ${(props) => (props.active ? "#99B0AD" : "#ccc")};
  transition: color 0.3s ease;
`;

const SwitchButton = styled.button`
  width: 50px;
  height: 26px;
  background: ${(props) => (props.active ? "#EE754C" : "#ddd")};
  border-radius: 50px;
  position: relative;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background 0.3s ease;
  padding: 3px;

  &:focus {
    outline: none;
  }
`;

const ToggleCircle = styled.div`
  width: 20px;
  height: 20px;
  background: #fff;
  border-radius: 50%;
  position: absolute;
  left: ${(props) => (props.active ? "calc(100% - 22px)" : "3px")};
  transition:
    left 0.3s ease,
    transform 0.2s ease;
  transform: ${(props) => (props.active ? "scale(1.1)" : "scale(1)")};
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
`;

const SwitchLabelButton = ({
  leftText = "OFF",
  rightText = "ON",
  defaultState = false,
  onToggle,
}) => {
  const [isOn, setIsOn] = useState(defaultState);

  useState(() => {
    setIsOn(defaultState);
  }, [defaultState]);

  const handleToggle = () => {
    setIsOn(!isOn);
    if (onToggle) onToggle(!isOn);
  };

  return (
    <SwitchWrapper>
      <LabelLeft active={!isOn}>{leftText}</LabelLeft>
      <SwitchButton active={isOn} onClick={handleToggle}>
        <ToggleCircle active={isOn} />
      </SwitchButton>
      <Label active={isOn}>{rightText}</Label>
    </SwitchWrapper>
  );
};

export default SwitchLabelButton;
